<template>
  <div
    class="back-form d-flex justify-content-center align-items-center"
    :class="{ 'back-form--close': isclose }"
    @click.self="tempProductHandler(true)"
  >
    <form action="#" @submit.prevent="formSubmitHandler">
      <h2>產品訊息</h2>
      <div class="d-flex">
        <div class="flex-grow-1">
          <div class="control-group">
            <input
              id="imageUrl"
              type="text"
              name="imageUrl"
              placeholder="輸入圖片網址"
              v-model="tempProduct.imageUrl[0]"
              required
            />
            <label for="imageUrl">
              輸入圖片網址
            </label>
          </div>
          <img :src="tempProduct.imageUrl[0]" alt="" />
        </div>
        <div class="flex-grow-1">
          <div class="control-group">
            <input
              id="title"
              type="text"
              name="title"
              placeholder="請輸入標題"
              v-model="tempProduct.title"
              required
            />
            <label for="title">標題</label>
          </div>
          <div class="d-flex">
            <div class="control-group flex-grow-1">
              <input
                id="category"
                type="text"
                name="category"
                placeholder="請輸入分類"
                v-model="tempProduct.category"
                required
              />
              <label for="category">分類</label>
            </div>
            <div class="control-group flex-grow-1">
              <input
                id="unit"
                type="text"
                name="unit"
                placeholder="請輸入單位"
                v-model="tempProduct.unit"
              />
              <label for="unit">單位</label>
            </div>
          </div>
          <div class="d-flex">
            <div class="control-group flex-grow-1">
              <input
                id="origin_price"
                type="number"
                name="origin_price"
                placeholder="請輸入原價"
                v-model.number="tempProduct.origin_price"
              />
              <label for="origin_price">原價</label>
            </div>
            <div class="control-group flex-grow-1">
              <input
                id="price"
                type="number"
                name="price"
                placeholder="請輸入售價"
                v-model.number="tempProduct.price"
              />
              <label for="price">售價</label>
            </div>
          </div>
          <div class="d-flex">
            <div class="control-group flex-grow-1">
              <textarea
                placeholder="請輸入產品描述"
                id="description"
                name="description"
                v-model="tempProduct.description"
                required
              >
              </textarea>
              <label for="description">產品描述</label>
            </div>
            <div class="control-group flex-grow-1">
              <textarea
                placeholder="請輸入產品內容"
                id="content"
                name="content"
                v-model="tempProduct.content"
                required
              >
              </textarea>
              <label for="content">說明內容</label>
            </div>
          </div>
          <div class="d-flex align-items-center mt-1">
            <input
              type="checkbox"
              name="is_enabled"
              id="is_enabled"
              v-model="tempProduct.enabled"
            />
            <label for="is_enabled">是否啟用</label>
          </div>
          <hr />
          <div class="text-right">
            <button class="transparent-btn" @click="tempProductHandler">
              取消
            </button>
            <button class="transparent-btn">
              送出
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: {
    isclose: {
      type: Boolean,
      default: true,
    },
    productId: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapState({
      user: 'user',
    }),
  },
  data() {
    return {
      tempProduct: {
        title: null,
        category: null,
        content: null,
        description: null,
        imageUrl: [],
        enabled: true,
        origin_price: null,
        price: null,
        unit: null,
        options: {
          comments: [],
        },
      },
    };
  },
  methods: {
    tempProductHandler(boolean) {
      this.$emit('close', boolean);
      this.tempProductInit();
    },
    tempProductInit() {
      this.tempProduct = {
        category: null,
        content: null,
        description: null,
        enabled: null,
        imageUrl: [],
        options: {},
        origin_price: null,
        price: null,
        title: null,
        unit: null,
      };
    },
    formSubmitHandler() {
      const { url: api } = new this.$adminUrl(
        false,
        this.user.uuid,
        this.user.apiPath,
        this.tempProduct.id && this.tempProduct.id,
      );
      let method;
      this.tempProduct.id ? (method = 'patch') : (method = 'post');
      //預設帶入 token
      this.axios.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
      this.axios[method](api, this.tempProduct).then(() => {
        this.$emit('refreshProducts');
      });
      this.$fire({
        title: `成功`,
        type: 'success',
        timer: 3000,
      });
    },
    formCancel() {
      this.formSubmitHandler(true);
      this.tempProductInit();
    },
  },
  watch: {
    productId(cur) {
      if (cur !== null) {
        const { url: apiGet } = new this.$adminUrl(
          false,
          this.user.uuid,
          this.user.apiPath,
          cur,
        );
        //預設帶入 token
        this.axios.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
        this.axios.get(apiGet).then(response => {
          this.tempProduct = response.data.data;
        });
        return true;
      }
      this.tempProduct = {
        imageUrl: '',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 5px;
  height: 10px;
}
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.1);
}
::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.5);
  background-color: rgba(255, 255, 255, 0.1);
}
</style>
